<template>
    <div>
        <div class="pl-[20px]">
            <div @click="$router.go(-1)" class="flex text-[#BD9135] items-center ml-3 mt-2 cursor-pointer">
                <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 17L1.56957 10.8258C0.810144 10.0966 0.810144 8.90341 1.56957 8.17424L8 2" stroke="#BD9135" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                </svg>
                <div class="ml-2 text-[#BD9135]">
                    Назад
                </div>
            </div>
        </div>

        <div class="text-white text-[24px] font-bold text-center">Опитування після матчу</div>

        <div v-if="!loading" class="w-[90%] mx-auto mt-[20px] mb-[20px]">
            <TableWrapper>
                <TableComponent :fullWidth="true">
                    <TableHeader>
                    <TableHeaderRow>
                        <TableHeaderCell :value="'гравець'" class="truncate"/>
                        <TableHeaderCell :value="'час на полі'" class="truncate"/>
                        <TableHeaderCell :value="'статус опитування'" />
                        <TableHeaderCell :value="''" />
                    </TableHeaderRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow  
                            v-for="player in students"
                        >
                            <TableCell :asChild="true" :width="50">
                                <div class="text-start flex">
                                    <div class="text-white ml-[10px] truncate" :title="player.name">
                                        {{ player.name }} {{ player.surname }}
                                    </div>
                                </div>
                            </TableCell>
                            <TableCell :asChild="true">
                                {{ player?.statistics ? player.statistics.player_game_time : '0' }} хв.
                            </TableCell>
                            <TableCell :asChild="true">
                                <div class="text-center flex justify-center">
                                    <div v-if="player?.survey" class="bg-[#339989] mx-2 h-[18px] flex justify-center items-center rounded-full w-[100px] text-[13px] text-center text-white">Пройдено</div>
                                    <div v-else class="bg-[#DA4167] mx-2 h-[18px] flex justify-center items-center rounded-full w-[100px] text-[13px] text-center text-white">Не пройдено</div>
                                </div>
                            </TableCell>
                            <TableCell :asChild="true">
                                <div class="h-[40px]">
                                    <button 
                                        v-if="player?.survey"
                                        class="py-1 rounded-[10px] text-sm font-medium text-red-600"
                                        @click="$router.push(`/after-match-survey-student/${player.student_id}/${player.survey.training_id}`)"
                                    >
                                        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 17.6458V7.05426C1 4.20025 1 2.77325 1.87868 1.88663C2.75736 1 4.17157 1 7 1H11C13.8284 1 15.2426 1 16.1213 1.88663C17 2.77325 17 4.20025 17 7.05426V17.6458C17 19.1575 17 19.9133 16.538 20.2108C15.7831 20.6971 14.6161 19.6774 14.0291 19.3073C13.5441 19.0014 13.3017 18.8485 13.0325 18.8397C12.7417 18.8301 12.4949 18.9768 11.9709 19.3073L10.06 20.5124C9.54454 20.8374 9.28679 21 9 21C8.71321 21 8.45546 20.8374 7.94 20.5124L6.02913 19.3073C5.54415 19.0014 5.30166 18.8485 5.03253 18.8397C4.74172 18.8301 4.49493 18.9768 3.97087 19.3073C3.38395 19.6774 2.21687 20.6971 1.46195 20.2108C1 19.9133 1 19.1575 1 17.6458Z" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 10H5" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11 6L5 6" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
    
                                    </button>
                                </div>

                            </TableCell>
                        </TableRow>
                    </TableBody>
                </TableComponent>
            </TableWrapper>
        </div>
        <div v-else class="flex justify-center items-center h-[300px]">
            <svg class="animate-spin h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="#BD9135" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    </div>
</template>
<script>
import { getAllStudentsListInGroup, getAllSurveysByTrainingId, getTrainingById, getPlayerStatisticsByMatchReportIdAndPlayerId } from '@/desktopApp/services/apiRequests'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';

export default {
    name: "AfterMatchSurvey",
    setup() {
        const students = ref([])
        const surveys = ref([])

        const training = ref(null)

        const route = useRoute();
        const matchId = route.params.training_id;
        const groupId = route.params.group_id;

        const loading = ref(true)

        onMounted(async () => {
            students.value = await getAllStudentsListInGroup(groupId)

            surveys.value = (await getAllSurveysByTrainingId(matchId)).surveys

            training.value = (await getTrainingById(matchId)).data

            console.log('surveys.value', surveys.value);
            console.log('students.value', students.value);
            console.log('training.value', training.value);

            for (let i = 0; i < students.value.length; i++) {
                const student = students.value[i]
                const statistics = await getPlayerStatisticsByMatchReportIdAndPlayerId(training.value.match_report_id, student.student_id)
                if (statistics) {
                    student.statistics = statistics
                }
                const survey = surveys.value.find(s => s.student_id === student.student_id)
                if (survey) {
                    student.survey = survey
                }
            }

            students.value = students.value.filter(s => s.statistics && +s.statistics.player_game_time >= 10)
            loading.value = false
        })

        return {
            students,
            surveys,
            loading
        }
    }
}
</script>
<style lang="scss"></style>